module.exports = __webpack_public_path__ + "img/thumb-009-07.21f6ac04.png";